/*
@author: Nikhil

jvDraggableTab
======================
Allows you build dragable tabs 

Usage:
============
li jv-draggable-tab tabs="applicationTabs" index="$index" ng-repeat="tabObject in applicationTabs" ng-show="{{tabObject.showCondition}}"  ng-class="{'active': currentTab == tabObject.tabType}"
@param applicationTabs : List of tab objects. Directive uses tabOrder property on the tab object to keep track of the order of a tab in the array.
@param index : Index of each item of the array.

@returns a sorted array of tab objects with updated tabOrder properties
*/
angular.module('jv.Common.Directives.Draggable.Tabs', [])

.directive('jvDraggableTab', function($timeout, $document) {
    var directiveDefinitionObject = {
            scope: {
                tabs: '=',
                index: '='
        },
        link: function(scope, element, attrs, controller) {
          // // Attempt to integrate with ngRepeat
          // // https://github.com/angular/angular.js/blob/master/src/ng/directive/ngRepeat.js#L211
          // var match = attrs.ngRepeat.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
            
          // scope.$watch(match[2], function(newTabs) {
          //   tabs = newTabs;
          // });
            var tabs = scope.tabs;
            var index = scope.index;

            scope.$watch('index', function(newIndex) {
                index = newIndex;
            });

            attrs.$set('draggable', true);
            
            var getTabIndex = function(tabType){
                var index;
                angular.forEach(scope.tabs,function(value,key){
                    if(value.tabType == tabType){
                        index = key;
                    }
                });
                return index;
            };

            //Wrapped in $apply so Angular reacts to changes
            var wrappedListeners = {
                // On item being dragged
                dragstart: function(e) {
                    e = e.originalEvent;
                    e.dataTransfer.effectAllowed = 'move';
                    e.dataTransfer.dropEffect = 'move';
                    e.dataTransfer.setData('Text',index);
                    element.addClass('dragging');
                },
                dragend: function(e) {
                  //e.stopPropagation();
                  element.removeClass('dragging');
                },

                // On item being dragged over / dropped onto
                dragenter: function(e) {
                },
                dragleave: function(e) {
                  element.removeClass('hover');
                },
                drop: function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e = e.originalEvent;
                    var sourceIndex = e.dataTransfer.getData('Text');
                    move(sourceIndex, index);
                    element.removeClass('hover');
                }
          };
          // For performance purposes, do not
          // call $apply for these
            var unwrappedListeners = {
                dragover: function(e) {
                  e.preventDefault();
                  element.addClass('hover');
                },
                /* Use .hover instead of :hover. :hover doesn't play well with 
                   moving DOM from under mouse when hovered */
                mouseenter: function() {
                  element.addClass('hover');
                },
                mouseleave: function() {
                  element.removeClass('hover');
                }
            };

            angular.forEach(wrappedListeners, function(listener, event) {
                element.on(event, wrap(listener));
            });
          
            angular.forEach(unwrappedListeners, function(listener, event) {
                element.on(event, listener);
            });

            function wrap(fn) {
                return function(e) {
                  scope.$apply(function() {
                    fn(e);
                  });
                };
            }

            function move(fromIndex, toIndex) {
                // http://stackoverflow.com/a/7180095/1319998
                tabs.splice(toIndex, 0, tabs.splice(fromIndex, 1)[0]);
                for(var i=0; i<tabs.length; i++){
                    var tabObj = tabs[i];
                    tabObj.tabOrder = i+1;
                }
            }
        }
    };
    return directiveDefinitionObject;
});

